import { useCallback, useEffect, useMemo } from "react";
import SALES_RECORD_TYPE from "../../../utils/variable";

const useDetailShortcut = (props) => {
  const { salesRecordType } = props;
  //ショットカット展開

  const SELL_COLUMN_COUNT = useMemo(
    () => (salesRecordType === SALES_RECORD_TYPE.LOCAL ? 2 : 6),
    [salesRecordType]
  );
  const handleKeyPress = useCallback(
    (event) => {
      if (event.key === "Enter") {
        if (event.location === 3) {
          event.preventDefault();
          focusNavigation(event.target, event.shiftKey);
        }
        //Left Enter + Shift
        else if (event.location === 0 && !event.shiftKey) {
          event.preventDefault();
          let firstSalesResult = document.getElementById(`salesResults-0-0`);
          if (firstSalesResult) firstSalesResult.focus();
        } else if (event.location === 0 && event.shiftKey) {
          event.preventDefault();
          let firstHeader = document.getElementById(`header-2`);
          if (firstHeader) firstHeader.focus();
        }
      }
    },
    [salesRecordType]
  );

  const handleKeyDown = useCallback(
    (event) => {
      //Arrow Handle
      const keyCode = event.keyCode;
      //Arrow Key
      if (keyCode === 37) {
        event.preventDefault();
        // Handle left arrow key press
        focusNavigation(event.target, true);
      } else if (keyCode === 39) {
        event.preventDefault();
        // Handle right arrow key press
        focusNavigation(event.target, false);
      } else if (keyCode === 38) {
        const ariaExpanded =
          event.target.getAttribute("aria-expanded") === "true" ? true : false;
        if (!ariaExpanded) {
          event.preventDefault();
          // Handle up arrow key press
          const focusingItem = document.activeElement.id;
          const currentRow = parseInt(focusingItem.split("-")[1]);
          const currentColumn = parseInt(focusingItem.split("-")[2]);
          if (currentRow === 0) moveToElement("header");
          else moveToElement("salesDetail", currentRow - 1, currentColumn);
        }
      } else if (keyCode === 40) {
        const ariaExpanded =
          event.target.getAttribute("aria-expanded") === "true" ? true : false;
        if (!ariaExpanded) {
          event.preventDefault();
          // Handle down arrow key press
          const focusingItem = document.activeElement.id;
          const currentRow = parseInt(focusingItem.split("-")[1]);
          const currentColumn = parseInt(focusingItem.split("-")[2]);
          moveToElement("salesDetail", currentRow + 1, currentColumn);
        }
      }
    },
    [salesRecordType]
  );

  const focusNavigation = useCallback(
    (currentElement, isPrevious = false) => {
      const focusing = currentElement.id;
      const step = isPrevious ? -1 : 1;
      const currentColumn = parseInt(focusing.split("-")[2], 10);
      const currentRow = parseInt(focusing.split("-")[1], 10);
      let nextColumn = currentColumn + step;
      let nextRow = currentRow;
      let district = "salesDetail";

      // 次の列
      if (isPrevious) {
        if (nextColumn < 0) nextColumn = SELL_COLUMN_COUNT - 1;
        if (currentColumn === 0) {
          if (currentRow === 0) {
            district = "header";
          } else {
            nextRow = currentRow - 1;
          }
        }
      } else {
        if (nextColumn === SELL_COLUMN_COUNT) {
          nextColumn = 0;
          nextRow = currentRow + 1;
        }
      }
      moveToElement(district, nextRow, nextColumn);
    },
    [salesRecordType]
  );

  const moveToElement = useCallback(
    (district, row = 0, column = 0) => {
      setTimeout(() => {
        const id =
          district !== "header" ? `${district}-${row}-${column}` : `header-16`;
        const element = document.getElementById(id);
        if (element) {
          element.focus();
        } else {
        }
      }, 0);
    },
    [salesRecordType]
  );
  return { handleKeyPress, handleKeyDown, focusNavigation };
};

export default useDetailShortcut;
